$(() => {
    appendArrow();

    let winWidth = $(window).width();

    // hover functionality
    $('#nav li').on('mouseenter', function () {
        if (winWidth > 990) {
            $(this).children('.sub').next().show();
            // Update aria-expanded for accessibility
            if ($(this).attr('aria-expanded') !== undefined) {
                $(this).attr('aria-expanded', 'true');
            }
        }
    }).on('mouseleave', function () {
        if (winWidth > 990) {
            $(this).children('.sub').next().hide();
            // Update aria-expanded for accessibility
            if ($(this).attr('aria-expanded') !== undefined) {
                $(this).attr('aria-expanded', 'false');
            }
        }
    });

    // subnav arrow click
    $('.subnavArrow').on('click', function () {
        $(this).parent().siblings().find('ul').slideUp();
        $(this).next().next().slideToggle();
        
        // Update aria-expanded for accessibility
        let parentLi = $(this).closest('li');
        if (parentLi.attr('aria-expanded') !== undefined) {
            let isExpanded = parentLi.attr('aria-expanded') === 'true';
            parentLi.attr('aria-expanded', !isExpanded);
        }
    });

    // window resize
    $(window).on('resize', function () {
        winWidth = $(window).width();
        if (winWidth > 990) {
            $('.navIcon').removeClass('navActive');
        } if (winWidth < 990) {
            $('.navBtn').removeClass('navActive');
            $('#nav').removeClass('active');
            $('#nav ul li ul').slideUp();
            // Reset SVG arrow states
            $('.subnavArrow').removeClass('active');
            $('.subnavArrow .arrow-open').show();
            $('.subnavArrow .arrow-close').hide();
        }
    });

    $('.subnavArrow').on('click', function () {
        let navActive = $(this).hasClass('active');
        if (!navActive) {
            $(this).addClass('active');
        }
        if (navActive) {
            $(this).removeClass('active');
        }

        // Toggle SVG arrow open/close icons
        $(this).find('.arrow-open').toggle(navActive);
        $(this).find('.arrow-close').toggle(!navActive);
        
        // Update aria-expanded for accessibility
        let parentLi = $(this).closest('li');
        if (parentLi.attr('aria-expanded') !== undefined) {
            parentLi.attr('aria-expanded', !navActive);
        }
    });

    // nav button click
    $('.navBtn').on('click', function () {
        let navActive = $('.navBtn').hasClass('navActive');
        if (!navActive) {
            $('.navBtn').addClass('navActive');
        }
        if (navActive) {
            $('.navBtn').removeClass('navActive');
        }
        if (!$('#nav').hasClass('active')) {
            $('#nav').addClass('active');
        } else {
            $('#nav').removeClass('active');
        }
    });

    // Keyboard accessibility for navigation dropdowns
    $('#nav li[aria-haspopup="true"]').on('keydown', function (e) {
        // Handle Enter (13) and Space (32) keys
        if (e.which === 13 || e.which === 32) {
            e.preventDefault();
            let isExpanded = $(this).attr('aria-expanded') === 'true';
            $(this).attr('aria-expanded', !isExpanded);
            
            // Toggle dropdown visibility
            if (winWidth > 990) {
                // Desktop behavior
                if (!isExpanded) {
                    $(this).children('.sub').next().show();
                } else {
                    $(this).children('.sub').next().hide();
                }
            } else {
                // Mobile behavior - trigger the subnav arrow click
                $(this).find('.subnavArrow').trigger('click');
            }
        }
    });

    // Focus event handlers for better keyboard navigation
    $('#nav li[aria-haspopup="true"]').on('focus', function () {
        // Ensure the element is highlighted when focused
        $(this).addClass('keyboard-focused');
    }).on('blur', function () {
        $(this).removeClass('keyboard-focused');
    });

    // filter toggles
    const filterHandlers = [
        { trigger: '.colorTitle', box: '.colorBox', others: ['.priceBox', '.itemsBox'] },
        { trigger: '.priceTitle', box: '.priceBox', others: ['.colorBox', '.itemsBox'] },
        { trigger: '.itemsTitle', box: '.itemsBox', others: ['.colorBox', '.priceBox'] }
    ];

    filterHandlers.forEach(({ trigger, box, others }) => {
        $(trigger).on('click', function () {
            if (winWidth < 667) {
                filterActive($(this));
                others.forEach(sel => $(sel).slideUp());
                $(box).slideToggle();
            }
        });
    });

    // character counter init
    charsCounter();
});

// Commented the code for stopping this Ajax request to Disabled checkremarketingreload for case 4256
// page reload code that should not be run on checkout and thank-you page
if (WebPageObj.customerReview) {
    // Shopper Approved widget removed for LLM/AI compatibility
    // Static content with server-side rendered reviews is now used

    // Toggle review form visibility
    $("#writeReview").on("click", () => {
        $('#avasReviewForm').toggleClass("hidden");
    });

    // Filters change handler
    $("#sortFilter, #ratingFilter").on("change", () => {
        loadReviews(1, true);
    });

    // Rating bar click → set filter
    $(".website-SA-review_bar").on("click", function () {
        const rating = $(this).data("rating");
        $("#ratingFilter").val(rating).trigger("change");
    });

    // Pagination click
    $("#site-pagination").on("click", "li.pageNumber", function () {
        const page = $(this).data("page");
        loadReviews(page, false);
    });

    // Next/Prev page handlers
    $(document).on("click", "#site-pagination > ul > li > span#nextPage", function () {
        const nextPageVal = $(this).attr("data-page");
        loadReviews(nextPageVal, false);
    });

    $(document).on("click", "#site-pagination > ul > li > span#prevPage", function () {
        const prevPageVal = $(this).attr("data-page");
        loadReviews(prevPageVal, false);
    });

    // Update pagination state
    function updatePagination(page) {
        const currentPage = parseInt(page, 10);
        $("#prevPage").attr("data-page", currentPage - 1);
        $("#nextPage").attr("data-page", currentPage + 1);

        $("#site-pagination li.active").removeClass("active");
        $(`#site-pagination li[data-page='${currentPage}']`).addClass("active");

        $("#site-pagination li span.site-pagination-prev")
            .toggleClass("hidden", currentPage === 1);

        const totalPages = parseInt($("#site-pagination li.pageNumber").last().data("page"), 10);
        $("#site-pagination li span.site-pagination-next")
            .toggleClass("hidden", currentPage === totalPages);
    }
    // Load reviews
    function loadReviews(page, reloadPagination) {
        const sortFilter = document.getElementById("sortFilter").value;
        const ratingFilter = document.getElementById("ratingFilter").value;
        $.ajax({
            url: '/ajax/loadMoreReviews',
            type: 'POST',
            headers: {
                'X-Requested-With': 'XMLHttpRequest'
            },
            data: {
                sortFilter: sortFilter,
                ratingFilter: ratingFilter,
                page: page,
                reloadPagination: reloadPagination
            },
            success: function(response) {
                // Append the new reviews HTML to the container
                $("#loadMoreReviews").html(response.reviewsHtml);
                
                if (reloadPagination || response.paginationHtml) {
                    if (response.paginationHtml) {
                        if ($("#site-pagination").hasClass('hidden')) {
                            $("#site-pagination").removeClass('hidden');
                        }
                        $("#site-pagination").html(response.paginationHtml);
                    } else {
                        if (!$("#site-pagination").hasClass('hidden')) {
                            $("#site-pagination").addClass('hidden');
                        }
                    }
                }
                updatePagination(page);
            },
            error: function(error) {
                logError(error);
            }
        });

      
    }
}
